import { ofType, combineEpics } from 'redux-observable';
import { switchMap, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax';
import { addNotification } from '@core-action';
import { NotificationType } from '@core-interface';
import {
  GET_PASSWORD_RESET_LINK, setPasswordResetLink
} from './forgetPassword.action';
import { StatusCode } from 'app-core/constant/authTypes';

export const epicGetForgetPasswordLink = (action$, state$) => {
  return action$.pipe(
    ofType(GET_PASSWORD_RESET_LINK),
    switchMap(({ payload }: any) => {
      const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
      const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
      const connection = process.env.REACT_APP_AUTH0_CONNECTION;

      return ajax({
        url: `${auth0Domain}/dbconnections/change_password`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          client_id: clientId,
          email: payload.Email,
          connection: connection
        }
      }).pipe(
        mergeMap((response: any) => {
          return of(
            setPasswordResetLink(StatusCode.success),
            addNotification({
              type: NotificationType.SUCCESS,
              messageKey: 'successfully_send_reset_link',
              message: `Successfully Send Reset Link to provided Email`,
            }),
          );
        }),
        catchError((error: any) => {
          return of(
            setPasswordResetLink(error.status || 500),
            addNotification({
              type: NotificationType.ERROR,
              messageKey: 'error_sending_reset_link',
              message: 'Error Sending Reset Link, Please try again',
            }),
          );
        })
      );
    })
  );
};

const ForgetPasswordEpic = combineEpics(
  epicGetForgetPasswordLink
);

export default ForgetPasswordEpic;